import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { unloadLpnSummaryChange } from "../../api";
import Navbar from "../../containers/navbar";
import MainHeader from "../../containers/header";
import Header from "../../containers/content_header";
import ReportTemplate from "../../containers/report_template";
import ErrorModal from "../../containers/error_modal";
import "./lpn.css";

const UnloadLpn = ({ ...props }) => {
  const { loc, locationName, widthIsSmall } = props;
  const [lpnSummaryList, setLpnSummaryList] = useState([]);
  const [allLpnSummaryList, setAllLpnSummaryList] = useState([]);
  const [filteredData, setfilteredData] = useState([]);
  const [itemKeys, setItemKeys] = useState([]);
  const [lambdaError, setLambdaError] = useState("");
  const [isListLoading, setIsListLoading] = useState(false);
  const [isdownloadLoading, setIsdownloadLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const openErrRef = useRef();
  const closeErrRef = useRef();
  const isFirstRender = useRef(true);
  const tableHeads = [
    "Item",
    "Item Desc",
    "Store",
    "Store Name",
    // "Yellow Lpn",
    "Lpn",
    "Type",
    "Qty",
    "Weight",
    "Date",
    "Aging",
    "Status",
    "user id",
  ];


  useEffect(() => {
    getLpnSummary();
  
    if (isFirstRender.current) {
      isFirstRender.current = false
      return;
    }
  }, [currentPage, searchText]);

  const getLpnSummary = async () => {
    try {
      setLpnSummaryList([]);
      setIsListLoading(true);
      let payload = {
        loc: loc,
        start: currentPage * 10,
        length: 10,
        search_key: searchText,
        file: false,
      };
      const resData = await unloadLpnSummaryChange(payload);

      if (resData) {
        if (resData?.status === "error") {
          setLambdaError(resData?.error_message);
          openErrRef.current.click();
        } else {
          if (Object.keys(resData?.body?.records)?.length) {
            let formattedData = resData?.body?.records?.map((lpn) => {
              return {
                item: lpn?.item,
                item_desc: lpn?.item_desc,
                store: lpn?.store,
                store_name: lpn?.store_name,
                // yellow_lpn: lpn?.yellow_lpn,
                lpn: lpn?.lpn,
                type: lpn?.type,
                qty: lpn?.qty,
                weight: lpn?.weight,
                date: lpn?.date,
                aging: lpn?.aging,
                status: lpn?.status,
                user_id: lpn?.user_id
              };
            });
            setLpnSummaryList(formattedData);
            setAllLpnSummaryList(formattedData);
            setfilteredData(formattedData);
            setItemKeys(Object.keys(formattedData[0]));
            setTotalRecords(resData?.body?.totalRecords);
          } else {
            setTotalRecords(resData?.body?.totalRecords);
          }
        }
        setIsListLoading(false);
      } else {
        // setLambdaError("Something went wrong");
        // openErrRef.current.click();
        setIsListLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLambdaError(error);
      openErrRef.current.click();
      setIsListLoading(false);
    }
  };

  const onDownLoadS3Url = async () => {
    try {
      setIsdownloadLoading(true);
      let payload = {
        loc: loc,
        start: 0,
        length: 0,
        search_key: searchText,
        file: true,
      };
      const resData = await unloadLpnSummaryChange(payload);

      if (resData) {
        if (resData?.status === "error") {
          setLambdaError(resData?.error_message);
          openErrRef.current.click();
        } else {
          if (resData?.body?.file_url) {
            window.open(resData?.body?.file_url);
          }
        }
      }
      //  else {
      //   setLambdaError("Something went wrong");
      //   openErrRef.current.click();
      // }
      setIsdownloadLoading(false);
    } catch (error) {
      console.log(error);
      setLambdaError(error);
      openErrRef.current.click();
      setIsdownloadLoading(false);
    }
  };

  const addPageData = (pageData) => {
    setLpnSummaryList(pageData);
  };

  return (
    <>
      <MainHeader />
      <Navbar />
      <div
        className="lpn-hm d-flex flex-column"
        style={{ padding: widthIsSmall ? "0px" : "8px 24px" }}
      >
        <Header
          text={`${loc} - ${locationName}`}
          headerText={"LPN Summary for Dispatch"}
        />
        <ReportTemplate
          widthIsSmall={widthIsSmall}
          tableHeads={tableHeads}
          itemKeys={itemKeys}
          data={lpnSummaryList}
          isTableLoading={isListLoading}
          loc={loc}
          buttonName={"Download LPN Summary For Dispatch"}
          filePrefix={"unloaded_LPN"}
          searchText={(text) => setSearchText(text)}
          allData={allLpnSummaryList}
          addPageData={addPageData}
          pageCount={10}
          filteredData={filteredData}
          totalRecords={totalRecords}
          type={"paginationFromDb"}
          changePage={(pageNo) => setCurrentPage(pageNo)}
          onDownloadUrl={onDownLoadS3Url}
          isdownloadLoading={isdownloadLoading}
        />
        <ErrorModal
          id={"errorModal"}
          openRef={openErrRef}
          closeRef={closeErrRef}
          headerColor={"red"}
          msg={lambdaError}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loc: state?.auth?.user?.loc,
    locationName: state?.auth?.user?.locationName,
    widthIsSmall: state?.auth?.widthIsSmall,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(UnloadLpn);
